<div class="container my-2">
  <div class="row easie-form">
    <div class="col-12 mx-auto">
      <p class="easie-form-label mb-0">Committee</p>
      <div class="input-group" *ngIf="canUpdate">
        <ion-select [(ngModel)]="pageSpecificFormObject.committeIds"  multiple="true" interface="popover" class="form-control-selectbox" 
          name="pageSpecificFormObject.committe" placeholder="Select" [disabled]="!canUpdate">
         <ion-select-option *ngFor="let level of committeeList" value="{{level.id}}">
           {{level.name}}
         </ion-select-option>
        </ion-select>
      </div>
    </div>
    <div class="col-12 mx-auto select-pills"  *ngIf="!canUpdate">
      <div class="row pt-1">
        <div class="col-1"></div>
        <div class="col-11">
          <div class="mb-1">
            <div *ngFor="let committee of committeeList">
              <div *ngIf="pageSpecificFormObject.committeIds && pageSpecificFormObject.committeIds.includes('' + committee.id)"
                  class="d-flex flex-row  align-items-center">
                <i class="fas fa-minus fa-xs"></i> &nbsp; <p class="font-weight-light mb-0">{{committee.name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
